// import { CanvasProvider } from "components/ThreeItems/CanvasProvider";
import { ReactElement, useEffect, useRef } from "react";
// import { useEditorContext } from "../EditorProvider";
// import { ThreeItems } from "components/ThreeItems/Exports";
import { Group, Matrix4, Vector3, Quaternion } from "three";

import { AxiosButtons } from "./AxiosButtons";
import { Properties } from "./properties";
// import { Actions } from "components/Actions/Actions";
import { useNavigate } from "react-router-dom";
import { PivotControls } from "@react-three/drei";
// import { SceneItemsType } from "components/ThreeItems/Scene";
import { useEditorContext } from "../editor-provider";
import { Scene } from "components/ThreeItems/Scene";
import { CanvasProvider } from "components/ThreeItems/CanvasProvider";
import { motion } from "framer-motion"
import { Box } from "lucide-react";
import { useLangContext } from "context/Lang";
import { Actions } from "components/Actions";
import { Material } from "./material";





type EditorEnvironmentProps = {
    canEdit?: boolean,
    inDialog?:boolean
}


export const EditorEnvironment = ({ canEdit,inDialog }: EditorEnvironmentProps): ReactElement => {

    const PivotRef = useRef<Group>(null);
    const isSelectedMeshRef = useRef<boolean>(false);
    const { gW } = useLangContext();
    const {
        handleDelete,
        getMeshes,
        addMesh,
        meshes,
        selectMesh,
        setSelectMesh,
        handleUpdate,
        handleLoadScene,
        handleSave,
        sceneItemsRef
    } = useEditorContext();

    const navigate = useNavigate();





    // useEffect(()=>{
    //     if(selectMesh){

    //     }

    // },[selectMesh]);

    const handleDrag = (l: Matrix4, w: Matrix4) => {
        const position = new Vector3();
        const quaternion = new Quaternion();
        const scale = new Vector3();

        l?.decompose?.(position, quaternion, scale);




        if (selectMesh) {

            //// Position
            const P_X = document.getElementsByName("positionX");
            const P_Y = document.getElementsByName("positionY");
            const P_Z = document.getElementsByName("positionZ");

            const p_x = Number(((position.x * Number(PivotRef.current?.scale.x)) + Number(PivotRef.current?.position.x))?.toFixed(2));
            const p_y = Number(((position.y * Number(PivotRef.current?.scale.y)) + Number(PivotRef.current?.position.y))?.toFixed(2));
            const p_z = Number(((position.z * Number(PivotRef.current?.scale.z)) + Number(PivotRef.current?.position.z))?.toFixed(2));

            if (P_X?.length > 0)
                (P_X[0] as HTMLInputElement).value = p_x + ""

            if (P_Y?.length > 0)
                (P_Y[0] as HTMLInputElement).value = p_y + ""

            if (P_Z?.length > 0)
                (P_Z[0] as HTMLInputElement).value = p_z + ""


            selectMesh.position.set(p_x, p_y, p_z);


            //// Scale
            const S_X = document.getElementsByName("scaleX");
            const S_Y = document.getElementsByName("scaleY");
            const S_Z = document.getElementsByName("scaleZ");


            const s_x = Number(((scale.x) + (Number(PivotRef.current?.scale.x) || 0) - 1)?.toFixed(2));
            const s_y = Number(((scale.y) + (Number(PivotRef.current?.scale.y) || 0) - 1)?.toFixed(2));
            const s_z = Number(((scale.z) + (Number(PivotRef.current?.scale.z) || 0) - 1)?.toFixed(2));

            if (S_X?.length > 0)
                (S_X[0] as HTMLInputElement).value = s_x + ""

            if (S_Y?.length > 0)
                (S_Y[0] as HTMLInputElement).value = s_y + ""

            if (S_Z?.length > 0)
                (S_Z[0] as HTMLInputElement).value = s_z + ""


            selectMesh.scale.set(s_x, s_y, s_z);


            selectMesh.updateMatrix();

            selectMesh.userData.isUpdate = true;
        }




    }




    useEffect(() => {
        if (!selectMesh) {
            isSelectedMeshRef.current = false;
        }
    }, [selectMesh])





    // useEffect(() => {
    //     loadMeshes();
    // }, [meshes]);


    return <div className="  " >



        <div className=" z-[1000]   absolute end-1 top-4 " >
            <Actions
                actions={!inDialog?["reload","back" ]:["reload"]}
                // onSave={() => handleSave?.(sceneItemsRef?.current?.scene?.children?.find(p => p?.name === "scene-group") || undefined)}
                onReload={() => { getMeshes?.() }}
                onBack={() => {
                    navigate(-1);
                }}
            />
        </div>

        {selectMesh && <motion.div
            initial={{ x: 100, opacity: 0.5 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            style={{ scale: 0.80 }}
            className=" overflow-hidden    bg-primary-50/70 backdrop-blur rounded-xl  border border-primary-300   select-none h-full overflow-y-auto   w-[400px] flex flex-col gap-2 absolute top-0 end-0 z-10 "
        >



            <div className="flex p-2 h-[15%]  items-center gap-3 overflow-hidden">
                <div className="p-3 bg-primary/20 rounded-lg text-primary shadow-[0_0_10px_rgba(var(--primary-rgb),0.3)]">
                    <Box size={28} />
                </div>
                <div className="flex flex-col overflow-hidden">
                    <span className="text-[10px] uppercase tracking-widest text-primary font-bold">
                        {gW("properties")}
                    </span>
                    <h3 className="text-sm font-semibold truncate text-primary-700 ">
                        {selectMesh?.name || "Unnamed Mesh"}
                    </h3>
                </div>
            </div>

            <div className=" h-[25%] " >
                {selectMesh&&<Material />}
            </div>

            <div className=" h-[60%] " >

                {selectMesh&&<Properties

                    animateType={{ animate: false }}
                    selectObject3DRef={{ current: selectMesh }}
                    PivotRef={PivotRef}

                    onCancel={() => {
                        if (!selectMesh.userData.id) {
                            sceneItemsRef?.current?.scene_group?.remove(selectMesh);
                        }
                        // selectMesh = selectMesh
                        setSelectMesh?.(null);
                        isSelectedMeshRef.current = false;
                    }}

                    onDelete={() => {
                        handleDelete?.({ mesh: selectMesh, effect: () => { isSelectedMeshRef.current = false } });
                    }}

                    onSave={() => {
                        if (selectMesh?.userData?.id) {
                            handleUpdate?.({ mesh: selectMesh, effect: () => { isSelectedMeshRef.current = false } })
                        } else {
                            handleSave?.({ mesh: selectMesh, effect: () => { isSelectedMeshRef.current = false } })
                        }
                    }}


                    onCopy={(e) => {
                        handleSave?.({ mesh: e.clone(), copy: true });
                    }}

                />}
            </div>
        </motion.div>}


        <CanvasProvider 
            className=" z-0 absolute top-0 left-0  h-full   w-full " 
            activePlaneHelper={false} 
            showSky={false} 
            planeShowHelper={true} 
            planeScale={[100, 100, 0]}
            gW={gW}
        >
            <Scene
                
                onSelect={(e) => {
                    if (canEdit && !isSelectedMeshRef.current) {
                        isSelectedMeshRef.current = true;
                        setSelectMesh?.(e)
                    }

                }}
                onLoad={(e) => handleLoadScene?.(e as SceneItemsProps)}
                isActiveSelect={canEdit}
                showHelper={false}
            />

            {/* <GetMeshes/>
                
            </ThreeItems.Scene> */}
            {selectMesh && <>
                <group position={selectMesh.position} scale={selectMesh.scale} ref={PivotRef}>
                    <PivotControls disableRotations={true} onDrag={handleDrag} scale={5} lineWidth={2} depthTest={false} >
                    </PivotControls>
                </group>
            </>}
            {/* <axesHelper ref={helperRef}  position={selectMesh.position} scale={[6,6,6]} /> */}
        </CanvasProvider>
    </div>
}




